import Default from './Default';

const InicioDefault = Default

export default InicioDefault;
